import CustomButton from "components/CustomButton/CustomButton";
import SpaceDialogAction from "./SpaceDialogAction";
import { Column } from "components/styles";

export const DialogStudentNotificationContent = ({
	description, students
}) => {
	return (
		<>
			<p className="paragraph center">
				{description}
			</p>
			<Column
				className="custom-scrollbar secondary"
				maxHeight="150px"
				align="center">
				<ul className="list">
					{students.map(({ id, name }) => (
						<li key={id} className="paragraph center">{id} ({name})<br /></li>
					))}
				</ul>
			</Column>
		</>
	);
}

const DialogStudentNotification = ({
	dialog, title,
	description, students
}) => {
	return (
		<SpaceDialogAction
			dialog={dialog}
			title={title}
			contentComponent={
				<DialogStudentNotificationContent description={description} students={students} />
			}>
			<CustomButton
				width="120px"
				text="Cerrar"
				onClick={dialog.hide} />
		</SpaceDialogAction>
	);
}

export default DialogStudentNotification;